import type { MessagePart } from 'tripPlanner/components/Chat/Message'

export function getTextFromParts(parts: Array<MessagePart>): string {
  return parts
    .filter((p): p is Extract<MessagePart, { type: 'text' }> => p.type === 'text')
    .map((p) => p.content)
    .join('\n\n')
}

export function getTripPlanMarkdownFromParts(parts: Array<MessagePart>): string {
  const tripPlanPart = parts.find(
    (p): p is Extract<MessagePart, { type: 'trip_plan_content' }> => p.type === 'trip_plan_content',
  )
  return tripPlanPart?.content ?? ''
}
